import $http from '@/api';
import $httpSilent from '@/api/without-catches';
import LRU from 'lru-cache';

const cache = new LRU({ maxAge: 1000 * 60 });

async function fetch(endpoint) {
  if (cache.has(endpoint)) {
    return cache.get(endpoint);
  }
  const response = await $httpSilent.get(endpoint);
  cache.set(endpoint, response);
  return response;
}

export default {
  async ping() {
    return $http.post('/api/milenium/ping');
  },
  async getPublications() {
    return fetch('/api/milenium/publications');
  },
  async getPublicationPlanillos(publicationId) {
    return fetch(`/api/milenium/publication/${publicationId}/planillos`);
  },
  async getPlanilloPages(planilloId) {
    return fetch(`/api/milenium/planillo/${planilloId}/pages`);
  },
  async getPagePositions(planilloId, pageId) {
    return fetch(`/api/milenium/planillo/${planilloId}/page/${pageId}/positions`);
  },

  // Wizard
  async getContentPagePositionWizard(contentId, publicationTypeId, publicationId, positionId) {
    return $httpSilent.get(`/api/milenium/content/${contentId}/publicationType/${publicationTypeId}/publication/${publicationId}/position/${positionId}`);
  },
  async createContentPagePosition(contentId, publicationTypeId, publicationId, positionId, payload) {
    return $http.post(`/api/milenium/content/${contentId}/publicationType/${publicationTypeId}/publication/${publicationId}/position/${positionId}`, payload);
  },


  // Editor
  async getContentPagePositionEditor(contentId) {
    return $http.get(`/api/milenium/content/${contentId}/editor`);
  },
  async patchContentPagePosition(contentId, payload) {
    return $http.patch(`/api/milenium/content/${contentId}/editor`, payload);
  },
  async finishContentPagePosition(contentId) {
    return $http.post(`/api/milenium/content/${contentId}/finish`);
  },
  async unlinkContentPagePosition(contentId) {
    return $http.post(`/api/milenium/content/${contentId}/unlink`);
  },
};
